if (typeof (window.console) === 'undefined') {
	window.console = {};
}

if (typeof (window.console.log) === 'undefined') {
	window.console.log = function () { };
}